module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "cot"
  }, [_vm._v("First and foremost, I want to thank Gary and Karin Tabke for going above and beyond the call of friendship. Your help was invaluable!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thank-yous all around for my core group of brainstormers—Jami Alden, Monica McCarty, Barbara Freethy, Anne Mallory, Candice Hern, Carol Grace Culver, Tracy Grant, Penelope Williamson, and Veronica Wolff. I’m blessed by all of your fantastic ideas (even the ones I don’t use!) and your endless encouragement. I feel so fortunate to have so many amazing, talented friends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thank you, Micki, for making the Bad Boys of Football a very sexy, very fun reality!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thank you "), _c('em', [_vm._v("so")]), _vm._v(" much to my readers. Your support is priceless! I had the best time writing "), _c('em', [_vm._v("Game for Anything")]), _vm._v(" and I sincerely hope you enjoy reading it as much as I loved writing it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And finally, thanks to all of the real Bad Boys of Football for being sinfully sexy and oh-so-bad!")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a13267","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Ack.vue
// module id = 69
// module chunks = 0